import API from "./APIService"
import BaseService from "./BaseService"

class IndustriesService extends BaseService {
	component = null

	constructor(component = null) {
		super()
		this.component = component
	}

	baseServicePath = () => {
		return API.url("industries")
	}
}

export default IndustriesService
